import api from '../helpers/apiHelper.js';
import {
	devConsoleLog,
	errorToast,
	// getUserData,
	// navigate,
	// redirectRoute,
	sessionDestroy,
	storeLocal,
	successToast,
} from '../helpers/projectHelper.js';

import {
	loginLoading,
	sessionSuccess,
	loginWebsite,
} from '../redux/slicers/sessionSlice.js';

import {
	LOGIN_API_ROOT,
	LOGIN_API,
	SIGNUP,
	ADMIN_LOGIN_API,
	LIVE_BROADCAST_API,
	ITIKAAF_REGISTRATION_API,
	SALAQEEN_API,
	FAQ_API,
	FAQ_CATEGORY_API,
	FAQ_CATEGORIES_API,
	EVENT_API,
	EVENTS_API,
	LIBRARY_API,
	LIVE_BROADCAST_CATEGORY_API,
	LIVE_BROADCAST_SUB_CATEGORY_API,
	CONTACT_US_API,
	REPLY_API,
	LIVE_AUDIO_API,
	FLOORPLANAPI,
	CREATEFLOORPLANAPI,
	CREATE_SUB_ADMIN,
	UPDATE_SUB_ADMIN,
	TOGGLE_SUBADMIN_STATUS,
	SUB_ADMIN_LIST,
	USER_LOGS,
	ADMIN_API,
	MASJID_API,
	MASJID_LIST_API,
	MASJID_CREATE_API,
	MASJID_UPDATE_API,
	MASJID_DELETE_API,
	MASJID_GET_BY_ID_API,
	EVENT_LIST_API,
	EVENT_CREATE_API,
	EVENT_GET_BY_ID_API,
	EVENT_UPDATE_API,
	EVENT_ARCHIVE_API,
	EVENT_DELETE_API,
	EVENT_TEST_NOTIFICATION_API,
	EVENT_INSPECT_CONFIRMATION_LETTER_TEMPLATE_API,
	EVENT_TEST_CONFIRMATION_LETTER_NOTIFICATION_API,
	MASJID_FLOOR_PLAN_TEMPLATE_API,
	EVENT_REGISTRATIONS_API,
	EVENT_REGISTRATIONS_STATS_API,
	EVENT_SCAN_QR_API,
	REGISTRATION_GET_BY_ID_API,
	REGISTRATION_ACCEPT_API,
	REGISTRATION_REJECT_API,
	REGISTRATION_BULK_ACCEPT_API,
	REGISTRATION_BULK_REJECT_API,
	REGISTRATION_BULK_SEND_CONFIRMATION_API,
	REGISTRATION_BULK_RESEND_NOTIFICATION_API,
	REGISTRATION_UPDATE_ITIKAAF_TYPE_API,
	REGISTRATION_SEND_CONFIRMATION_API,
	REGISTRATION_ASSIGN_SEAT_API,
	REGISTRATION_BULK_ASSIGN_SEATS_API,
	REGISTRATION_UNASSIGN_SEAT_API,
	REGISTRATION_SWAP_SEATS_API,
	REGISTRATION_DELETE_API,
	EVENT_SEAT_MAP_API,
	PRINT_BATCH_CREATE_API,
	PRINT_BATCH_STATUS_API,
	PRINT_BATCH_LIST_API,
	USERS_LIST_API,
} from '../config/constants/apiConstant.js';

import {
	ADMIN_LOGIN,
	DASHBOARD,
	FLOOR_PLAN,
	ADMIN_VISITORS,
} from '../config/constants/routePathConstants.js';

import { ROLE_NAV, USER_DATA } from '../config/constants/projectConstant.js';
import { getSignUpPopUP } from '../redux/slicers/userSlice.js';
import {
	getFaqCategoryLists,
	getFaqLists,
	getLiveBroadCasts,
	getSalaqeenLists,
	getSingleLiveBroadCast,
	getUserLists,
	getDashboardLists,
	getEventLists,
	getBookLists,
	getLiveBroadCastCategories,
	getLiveBroadCastSubCategories,
	getMessageLists,
	getAudioLists,
	getFloorPlanLists,
	getFloorPlanListsById,
	getSubAdminsList,
	getLogsList,
	getServerErrorsList,
	getQrEventLogsList,
	getRegisteredUsersList,
} from '../redux/slicers/adminSlice.js';
import { setAccess } from '../redux/slicers/activitySlice.js';
import Swal from 'sweetalert2';
import myAxiosInstance from '../helpers/axiosInstace.js';

export const adminLoginApi =
	(formData, navigate, setLoadingbtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(ADMIN_LOGIN_API)
			.data(formData)
			.success((a) => {
				const { message: msg = '' } = a;
				setLoadingbtn(false);
				if (a.statusCode === 200) {
					const { data = {} } = a;
					storeLocal(data, USER_DATA);
					storeLocal(data.token, 'token');
					if (data.role === 'visitor') {
						navigate(ADMIN_VISITORS);
					} else {
						navigate(DASHBOARD);
					}
					dispatch(setAccess(data.token));
					successToast(msg);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoadingbtn(false);
				errorToast(msg);
			})
			.send(() => {
				dispatch(loginLoading(false));
			});
	};



export const createSubAdminApi =
	(formData, setLoading, handleClose, getUsersList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(CREATE_SUB_ADMIN)
			.data(formData)
			.success((a) => {
				setLoading(false);
				if (a.statusCode === 201) {
					successToast(a.message);
					getUsersList();
					handleClose();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading(false);
			})
			.send(() => { });
	};

export const updateSubAdminApi =
	(formData, setLoading, handleClose, getUsersList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(UPDATE_SUB_ADMIN)
			.data(formData)
			.success((a) => {
				setLoading(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getUsersList();
					handleClose();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading(false);
			})
			.send(() => { });
	};

export const toggleSubAdminStatusApi =
	(userId, setLoading, getUsersList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(TOGGLE_SUBADMIN_STATUS)
			.data({ userId })
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getUsersList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const getSubAdminsListApi =
	(SIZE, setListsize, page, setLoading, search) => (dispatch) => {
		const isSearch =
			search?.length > 0
				? `search=${search}&page=${page}&limit=${SIZE}`
				: `page=${page}&limit=${SIZE}`;
		api()
			.root(LOGIN_API_ROOT)
			.get(`${SUB_ADMIN_LIST}?${isSearch}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					dispatch(getSubAdminsList(a?.data?.data || []));
					setListsize(a?.data?.totalCounts || 0);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				dispatch(getSubAdminsList([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const getLogsListApi =
	(SIZE, setListsize, page, setLoading, search) => (dispatch) => {
		const isSearch =
			search?.length > 0
				? `search=${search}&page=${page}&limit=${SIZE}`
				: `page=${page}&limit=${SIZE}`;

		api()
			.root(LOGIN_API_ROOT)
			.get(`${USER_LOGS}?${isSearch}`)
			.success((res) => {
				setLoading && setLoading(false);

				if (res.statusCode === 200) {
					dispatch(getLogsList(res?.data?.data || []));
					setListsize(res?.data?.totalCounts || 0);
				}

				if (
					res.statusCode === 400 ||
					res.statusCode === 401 ||
					res.statusCode === 403 ||
					res.statusCode === 404
				) {
					errorToast(res.message);
				}
			})
			.error((err) => {
				const { message: msg = '' } = err;
				errorToast(msg);
				dispatch(getLogsList([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const getServerErrorsListApi =
	(SIZE, setListsize, page, setLoading, search) => (dispatch) => {
		const isSearch =
			search?.length > 0
				? `search=${search}&page=${page}&limit=${SIZE}&sortBy=-createdAt`
				: `page=${page}&limit=${SIZE}&sortBy=-createdAt`;

		api()
			.root(LOGIN_API_ROOT)
			.get(`${ADMIN_API}errors?${isSearch}`)
			.success((res) => {
				setLoading && setLoading(false);

				if (res.statusCode === 200) {
					dispatch(getServerErrorsList(res?.data?.data || []));
					setListsize(res?.data?.totalCounts || 0);
				}

				if (
					res.statusCode === 400 ||
					res.statusCode === 401 ||
					res.statusCode === 403 ||
					res.statusCode === 404
				) {
					errorToast(res.message);
				}
			})
			.error((err) => {
				const { message: msg = '' } = err;
				errorToast(msg);
				dispatch(getServerErrorsList([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const logoutApi = () => () => {
	sessionDestroy();
};

export const signUpApi =
	(formData, setPhone, setBtnDisabled, setReCapValue) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(SIGNUP)
			.data({
				phone_number: formData.phone,
			})
			.success((a) => {
				if (a.status === 200) {
					successToast(a.message);
					dispatch(getSignUpPopUP(false));
					setPhone();
					setBtnDisabled(false);
					setReCapValue('');
				}
				if (
					a.status === 400 ||
					a.status === 401 ||
					a.status === 403 ||
					a.status === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

//start -----------live broadcast--------------------
export const addLiveBroadcastApi =
	(formData, setLoading, handleClose, playlist, SIZE, setListsize, page) =>
		(dispatch) => {
			api()
				.root(LOGIN_API_ROOT)
				.post(LIVE_BROADCAST_API)
				.data(formData)
				.success((a) => {
					handleClose();
					setLoading(false);
					if (a.statusCode === 200) {
						successToast(a?.message);
						dispatch(
							getLiveBroadcastApi(playlist, SIZE, setListsize, page, setLoading),
						);
					}
					if (
						a.statusCode === 400 ||
						a.statusCode === 401 ||
						a.statusCode === 403 ||
						a.statusCode === 404
					) {
						errorToast(a.message);
					}
				})
				.error((e) => {
					handleClose();
					setLoading(false);
					const { message: msg = '' } = e;
					errorToast(msg);
				})
				.send(() => { });
		};

export const updateLiveBroadcastApi =
	(formData, id, setLoading, handleClose, playlist, SIZE, setListsize, page) =>
		(dispatch) => {
			api()
				.root(LOGIN_API_ROOT)
				.put(`${LIVE_BROADCAST_API}${id}`)
				.data(formData)
				.success((a) => {
					handleClose();
					setLoading(false);
					if (a.statusCode === 200) {
						successToast(a?.message);
						dispatch(
							getLiveBroadcastApi(playlist, SIZE, setListsize, page, setLoading),
						);
					}
					if (
						a.statusCode === 400 ||
						a.statusCode === 401 ||
						a.statusCode === 403 ||
						a.statusCode === 404
					) {
						errorToast(a.message);
					}
				})
				.error((e) => {
					handleClose();
					setLoading(false);
					const { message: msg = '' } = e;
					errorToast(msg);
				})
				.send(() => { });
		};

export const getLiveBroadcastApi =
	(playlist, SIZE, setListsize, page, setLoading) => (dispatch) => {
		const videoUrl = playlist
			? `${LIVE_BROADCAST_API}${playlist}&page=${page}&limit=${SIZE}`
			: `${LIVE_BROADCAST_API}?page=${page}&limit=${SIZE}`;
		api()
			.root(LOGIN_API_ROOT)
			.get(videoUrl)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					setListsize(a?.data?.totalCounts);
					dispatch(getLiveBroadCasts(a?.data?.data));
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					// errorToast(a.message);
					setLoading && setLoading(false);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				// errorToast(msg);
				dispatch(getLiveBroadCasts([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const getSingleLiveBroadcastApi = (setLoading) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.get(`${LIVE_BROADCAST_API}`)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200) {
				dispatch(getSingleLiveBroadCast(a?.data?.data?.[0]));
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				// errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			// errorToast(msg);
			dispatch(getLiveBroadCasts([]));
			setLoading && setLoading(false);
		})
		.send(() => { });
};

export const deleteLiveBroadcastApi =
	(id, playlist, SIZE, setListsize, page, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.delete(`${LIVE_BROADCAST_API}${id}`)
			.success((a) => {
				if (a.statusCode === 200) {
					successToast(a.message);
					dispatch(
						getLiveBroadcastApi(playlist, SIZE, setListsize, page, setLoading),
					);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

// start -------------live broadcast  category----------

export const getLiveBroadCastCategoryApi = (setLoading) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.get(LIVE_BROADCAST_CATEGORY_API)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200) {
				dispatch(getLiveBroadCastCategories(a?.data));
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
			dispatch(getLiveBroadCastCategories([]));
			setLoading && setLoading(false);
		})
		.send(() => { });
};

export const addLiveBroadCastCategoryApi =
	(formData, handleClose, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(LIVE_BROADCAST_CATEGORY_API)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoading && setLoading(false);
				if (a.statusCode === 201) {
					successToast(a.message);
					dispatch(getLiveBroadCastCategoryApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				handleClose();
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const deleteLiveBroadCastCategoryApi = (id) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.delete(`${LIVE_BROADCAST_CATEGORY_API}${id}`)
		.success((a) => {
			if (a.statusCode === 200) {
				successToast(a.message);
				dispatch(getLiveBroadCastCategoryApi());
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
		})
		.send(() => { });
};

export const updateLiveBroadCastCategoryApi =
	(formData, id, setLoading, handleUpdClose) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${LIVE_BROADCAST_CATEGORY_API}${id}`)
			.data(formData)
			.success((a) => {
				handleUpdClose();
				setLoading(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					dispatch(getLiveBroadCastCategoryApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				handleUpdClose();
				setLoading(false);
				errorToast(msg);
			})
			.send(() => { });
	};

// start -------------live broadcast sub category----------

export const getLiveBroadCastSubCategoryApi = (setLoading) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.get(LIVE_BROADCAST_SUB_CATEGORY_API)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200) {
				dispatch(getLiveBroadCastSubCategories(a?.data));
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
			dispatch(getLiveBroadCastSubCategories([]));
			setLoading && setLoading(false);
		})
		.send(() => { });
};

export const addLiveBroadCastSubCategoryApi =
	(formData, handleClose, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(LIVE_BROADCAST_SUB_CATEGORY_API)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoading && setLoading(false);
				if (a.statusCode === 201) {
					successToast(a.message);
					dispatch(getLiveBroadCastSubCategoryApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				handleClose();
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const deleteLiveBroadCastSubCategoryApi = (id) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.delete(`${LIVE_BROADCAST_SUB_CATEGORY_API}${id}`)
		.success((a) => {
			if (a.statusCode === 200) {
				successToast(a.message);
				dispatch(getLiveBroadCastSubCategoryApi());
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
		})
		.send(() => { });
};

export const updateLiveBroadCastSubCategoryApi =
	(formData, id, setLoading, handleUpdClose) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${LIVE_BROADCAST_SUB_CATEGORY_API}${id}`)
			.data(formData)
			.success((a) => {
				handleUpdClose();
				setLoading(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					dispatch(getLiveBroadCastSubCategoryApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				handleUpdClose();
				setLoading(false);
				errorToast(msg);
			})
			.send(() => { });
	};

//end -----------live broadcast--------------------

export const sendParticipationNotificationApi =
	(id, updateState, updateLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_REGISTRATION_API}participation-notify/${id}`)
			.success((a) => {
				if (a.statusCode === 200 || a.statusCode === 201) {
					updateState();
					updateLoading();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					updateLoading();
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

export const bulkSendParticipationNotificationApi =
	(ids, postStateUpdate, setLoadingBtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_REGISTRATION_API}bulk-participation-notify`)
			.data({ ids })
			.success((a) => {
				setLoadingBtn && setLoadingBtn(false);

				if (a.statusCode === 200 || a.statusCode === 201) {
					postStateUpdate();
				} else if ([400, 401, 403, 404].includes(a.statusCode)) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				setLoadingBtn && setLoadingBtn(false);

				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

export const acceptAndRegisterItakaafUserApi =
	(status, id, getUserList, setLoadingBtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`${ITIKAAF_REGISTRATION_API}${status}/${id}`)
			.success((a) => {
				setLoadingBtn && setLoadingBtn(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					getUserList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn && setLoadingBtn(false);
			})
			.send(() => { });
	};

export const bulkAcceptItakaafUserApi =
	(ids, getUserList, setLoadingBtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_REGISTRATION_API}bulkaccept`)
			.data({ ids })
			.success((a) => {
				setLoadingBtn && setLoadingBtn(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					getUserList();
				} else if ([400, 401, 403, 404].includes(a.statusCode)) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn && setLoadingBtn(false);
			})
			.send(() => { });
	};

export const updateUserEtikaafTypeApi =
	(id, etikaafType, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${ITIKAAF_REGISTRATION_API}updateEtikaafType/${id}`)
			.data({ etikaafType })
			.success((a) => {
				if (a.statusCode === 200 || a.statusCode === 201) {
					onSuccess && onSuccess();
				} else if ([400, 401, 403, 404].includes(a.statusCode)) {
					errorToast(a.message);
					onFailure && onFailure();
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				onFailure && onFailure();
			})
			.send(() => { });
	};

export const inviteUserRegistrationApi =
	(userData, setLoading) => (dispatch) => {
		setLoading && setLoading(true);
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_REGISTRATION_API}registrationinvite`)
			.data(userData)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					successToast(a.message);
				} else if ([400, 401, 403, 404].includes(a.statusCode)) {
					errorToast(a.message || 'Failed to send invitation.');
				}
			})
			.error((e) => {
				setLoading && setLoading(false);
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

export const getUserListApi =
	(status, SIZE, setListsize, page, setLoading, masjidValue, filters = {}) =>
		(dispatch) => {
			const params = new URLSearchParams();
			params.append('status', status);
			params.append('page', page);
			params.append('limit', SIZE);

			if (filters.state) {
				params.append('state', filters.state);
			}
			if (filters.city) {
				params.append('city', filters.city);
			}
			if (filters.etikafType) {
				params.append('typeOfIthikaaf', filters.etikafType);
			}
			if (filters.khidmat) {
				params.append('typeOfQidmat', filters.khidmat);
			}
			if (filters.search) {
				params.append('search', filters.search);
			}

			if (filters.isUserConfirmed) {
				params.append('isUserConfirmed', filters.isUserConfirmed);
			}

			const url = `${ITIKAAF_REGISTRATION_API}${masjidValue}?${params.toString()}`;

			api()
				.root(LOGIN_API_ROOT)
				.get(url)
				.success((a) => {
					if (a.statusCode === 200) {
						setListsize(a?.data?.totalCounts);
						dispatch(getUserLists(a?.data?.data));
					}
					if (
						a.statusCode === 400 ||
						a.statusCode === 401 ||
						a.statusCode === 403 ||
						a.statusCode === 404
					) {
						dispatch(getUserLists([]));
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					dispatch(getUserLists([]));
					setLoading(false);
				})
				.send(() => {
					setLoading(false);
				});
		};

export const exportUserListApi =
	(status, masjidValue, filters = {}) =>
		(dispatch) => {
			const params = new URLSearchParams();
			params.append('status', status);
			if (filters.state) params.append('state', filters.state);
			if (filters.city) params.append('city', filters.city);
			if (filters.etikafType) params.append('typeOfIthikaaf', filters.etikafType);
			if (filters.khidmat) params.append('typeOfQidmat', filters.khidmat);
			if (filters.search) params.append('search', filters.search);

			const url = `${ITIKAAF_REGISTRATION_API}users/${masjidValue}/export?${params.toString()}`;

			api()
				.root(LOGIN_API_ROOT)
				.get(url)
				.success((response) => {
					const bufferArray = response.data.data;
					const fileBuffer = new Uint8Array(bufferArray);
					const blob = new Blob([fileBuffer], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					});
					const downloadUrl = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = downloadUrl;
					a.download = `${status}-users.xlsx`;
					document.body.appendChild(a);
					a.click();
					a.remove();
					setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 100);
				})
				.error((e) => {
					console.error('Export failed', e);
				})
				.send();
		};

// Start Admin Dashboard API

export const getDashboardApi =
	(setListsize, setLoading, setDashboardList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`${'/athikaaf/dashboard/'}`)
			.success((a) => {
				if (a.statusCode === 200) {
					setListsize(a?.data?.totalCounts);
					setDashboardList(a?.data);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					// errorToast(a.message);
					setDashboardList([]);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				// errorToast(msg);
				setDashboardList([]);
				setLoading(false);
			})
			.send(() => {
				setLoading(false);
			});
	};

// End Admin Dashboard API

export const getAssignedUserListApi =
	(
		status,
		SIZE,
		setListsize,
		page,
		setLoading,
		masjidId,
		setAssignedUserList,
	) =>
		(dispatch) => {
			api()
				.root(LOGIN_API_ROOT)
				.get(
					`${'/athikaaf/get-status-by-seat/'}${masjidId}?status=assigned&page=${page}&limit=${SIZE}`,
				)
				.success((a) => {
					if (a.statusCode === 200) {
						setListsize(a?.data?.totalCounts);
						setAssignedUserList(a?.data?.data);
					}
					if (
						a.statusCode === 400 ||
						a.statusCode === 401 ||
						a.statusCode === 403 ||
						a.statusCode === 404
					) {
						// errorToast(a.message);
						setAssignedUserList([]);
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					// errorToast(msg);
					setAssignedUserList([]);
					setLoading(false);
				})
				.send(() => {
					setLoading(false);
				});
		};

export const getCityBasedList =
	(masjidId, SIZE, setListsize, page, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`/athikaaf/confirmed-user/${masjidId}?page=${page}&limit=${SIZE}`)
			.success((a) => {
				if (a.statusCode === 200) {
					setListsize(a?.data?.totalCounts);
					dispatch(getUserLists(a?.data?.data));
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => {
				setLoading(false);
			});
	};

export const getCityBasedUserList =
	(
		city,
		masjidId,
		SIZE,
		setListsize,
		page,
		setLoading,
		listStatus,
		filters = {},
	) =>
		(dispatch) => {
			const params = new URLSearchParams();
			params.append('status', listStatus);
			params.append('page', page);
			params.append('limit', SIZE);

			if (filters.itikafType) {
				params.append('typeOfIthikaaf', filters.itikafType);
			}

			if (filters.khidmat) {
				params.append('typeOfQidmat', filters.khidmat);
			}

			if (filters.search) {
				params.append('search', filters.search);
			}

			api()
				.root(LOGIN_API_ROOT)
				.get(`/athikaaf/confirmed-user/${city}/${masjidId}?${params.toString()}`)
				.success((a) => {
					if (a.statusCode === 200) {
						setListsize(a?.data?.totalCounts);
						dispatch(getUserLists(a?.data?.data));
					}
					if (
						a.statusCode === 400 ||
						a.statusCode === 401 ||
						a.statusCode === 403 ||
						a.statusCode === 404
					) {
						errorToast(a.message);
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					errorToast(msg);
				})
				.send(() => {
					setLoading(false);
				});
		};

export const getCityBasedUserListWithoutPagination =
	(city, masjidId, setLoading, setUserList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`/athikaaf/confirmed-user/${city}/${masjidId}`)
			.success((a) => {
				if (a.statusCode === 200) {
					setUserList(a?.data?.data);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => {
				setLoading(false);
			});
	};

//start -----------salaqeen--------------------

export const getSalaqeenListApi =
	(SIZE, setListsize, page, setLoading, search) => (dispatch) => {
		const isSearch =
			search?.length > 0
				? `search=${search}&page=${page}&limit=${SIZE}`
				: `page=${page}&limit=${SIZE}`;
		api()
			.root(LOGIN_API_ROOT)
			.get(`${SALAQEEN_API}?${isSearch}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					dispatch(getSalaqeenLists(a?.data?.data));
					setListsize(a?.data?.totalCounts);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				dispatch(getSalaqeenLists([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const deleteSalaqeenApi =
	(id, getSalaqeenList, setLoadingBtn, setDelOpen) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.delete(`${SALAQEEN_API}${id}`)
			.success((a) => {
				setLoadingBtn(false);
				setDelOpen(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getSalaqeenList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn(false);
				setDelOpen(false);
			})
			.send(() => { });
	};

export const updateSalaqeenApi =
	(formData, id, handleClose, setLoading, getSalaqeenList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${SALAQEEN_API}${id}`)
			.data(formData)
			.success((a) => {
				setLoading(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getSalaqeenList();
					handleClose();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading(false);
				handleClose();
			})
			.send(() => { });
	};

//end -----------salaqeen--------------------

//start -----------registered users--------------------

export const getRegisteredUsersListApi =
	(SIZE, setListsize, page, setLoading, search) => (dispatch) => {
		const isSearch =
			search?.length > 0
				? `search=${search}&page=${page}&limit=${SIZE}`
				: `page=${page}&limit=${SIZE}`;
		api()
			.root(LOGIN_API_ROOT)
			.get(`${USERS_LIST_API}?${isSearch}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					dispatch(getRegisteredUsersList(a?.data?.data));
					setListsize(a?.data?.total);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				dispatch(getRegisteredUsersList([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

//end -----------registered users--------------------

export const getFaqListApi = (setLoading) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.get(FAQ_API)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200) {
				dispatch(getFaqLists(a?.data));
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
			dispatch(getFaqLists([]));
			setLoading && setLoading(false);
		})
		.send(() => { });
};

export const addFaqListApi =
	(formData, handleClose, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(FAQ_API)
			.data(formData)
			.success((a) => {
				setLoading && setLoading(false);
				handleClose();
				if (a.statusCode === 201) {
					dispatch(getFaqListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				dispatch(getFaqLists([]));
				handleClose();
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const addExistingFaqListApi =
	(formData, setLoading, handleAddFaqClose) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(FAQ_API)
			.data(formData)
			.success((a) => {
				setLoading && setLoading(false);
				handleAddFaqClose(false);
				if (a.statusCode === 200) {
					dispatch(getFaqListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				handleAddFaqClose(false);
				dispatch(getFaqLists([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const updateQnAnsApi =
	(formData, handleClose, setLoadingBtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(FAQ_API)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoadingBtn(false);
				if (a.statusCode === 200) {
					successToast(a?.message);
					dispatch(getFaqListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				handleClose();
				setLoadingBtn(false);
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

export const deleteFaqApi = (id) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.delete(`${FAQ_API}${id}`)
		.success((a) => {
			if (a.statusCode === 200) {
				successToast(a.message);
				dispatch(getFaqListApi());
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
		})
		.send(() => { });
};

export const deleteFaqQnAnsApi =
	(categoryId, id, setLoadingBtn, setDelOpen) => (dispatch) => {
		const apiPath = (id = ''
			? `${FAQ_API}${categoryId}`
			: `${FAQ_API}${categoryId}/${id}`);
		api()
			.root(LOGIN_API_ROOT)
			.delete(apiPath)
			.success((a) => {
				setLoadingBtn(false);
				setDelOpen(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					dispatch(getFaqListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn(false);
				setDelOpen(false);
			})
			.send(() => { });
	};

//start---------FAQ Category-----------

export const getFaqCategoryListApi = (setLoading) => (dispatch) => {
	api()
		.root(LOGIN_API_ROOT)
		.get(FAQ_CATEGORIES_API)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200) {
				dispatch(getFaqCategoryLists(a?.data));
			}
			if (
				a.statusCode === 400 ||
				a.statusCode === 401 ||
				a.statusCode === 403 ||
				a.statusCode === 404
			) {
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
			dispatch(getFaqCategoryLists([]));
			setLoading && setLoading(false);
		})
		.send(() => { });
};

export const addFaqCategoryListApi =
	(formData, handleClose, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(FAQ_CATEGORY_API)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoading && setLoading(false);
				if (a.statusCode === 201) {
					dispatch(getFaqCategoryListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				handleClose();
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const deleteFaqCategoryApi =
	(id, setLoadingBtn, setDelOpen) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.delete(`${FAQ_CATEGORY_API}${id}`)
			.success((a) => {
				setLoadingBtn(false);
				setDelOpen(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					dispatch(getFaqCategoryListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn(false);
				setDelOpen(false);
			})
			.send(() => { });
	};

export const updateFaqCategoryApi =
	(formData, id, handleUpdClose, setLoadingBtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${FAQ_CATEGORY_API}${id}`)
			.data(formData)
			.success((a) => {
				setLoadingBtn(false);
				handleUpdClose();
				if (a.statusCode === 200) {
					successToast(a.message);
					dispatch(getFaqCategoryListApi());
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				handleUpdClose();
				setLoadingBtn(false);
				errorToast(msg);
			})
			.send(() => { });
	};

//start--------event--------------------

export const getEventListsApi =
	(SIZE, setListsize, page, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(EVENTS_API)
			.get(`${EVENTS_API}?page=${page}&limit=${SIZE}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					setListsize(a?.data?.totalCounts);
					dispatch(getEventLists(a?.data?.data));
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					// errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				// errorToast(msg);
				dispatch(getEventLists([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const addEventListsApi =
	(formData, handleClose, setLoading, getEventList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(EVENT_API)
			.data(formData)
			.success((a) => {
				setLoading && setLoading(false);
				handleClose();
				if (a.statusCode === 201) {
					successToast(a?.message);
					getEventList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				handleClose();
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const deleteEventListsApi =
	(id, setLoadingBtn, setDelOpen, getEventList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.delete(`${EVENT_API}${id}`)
			.success((a) => {
				setLoadingBtn(false);
				setDelOpen(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getEventList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoadingBtn(false);
				setDelOpen(false);
				errorToast(msg);
			})
			.send(() => { });
	};

export const updateEventListsApi =
	(formData, id, setLoading, handleUpdClose, getEventList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${EVENT_API}${id}`)
			.data(formData)
			.success((a) => {
				handleUpdClose();
				setLoading && setLoading(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					successToast(a.message);
					getEventList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				handleUpdClose();
				setLoading && setLoading(false);
				errorToast(msg);
			})
			.send(() => { });
	};

//start--------library--------------------

export const getBookListsApi =
	(SIZE, setListsize, page, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`${LIBRARY_API}?page=${page}&limit=${SIZE}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					setListsize(a?.data?.totalCounts);
					dispatch(getBookLists(a?.data?.data));
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					// errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				// errorToast(msg);
				dispatch(getBookLists([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const addBookListsApi =
	(formData, handleClose, setLoadingBtn, getBookList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(LIBRARY_API)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoadingBtn(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					successToast(a?.message);
					getBookList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				handleClose();
				setLoadingBtn(false);
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

export const deleteBookListsApi =
	(id, setLoadingBtn, setDelOpen, getBookList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.delete(`${LIBRARY_API}${id}`)
			.success((a) => {
				setLoadingBtn(false);
				setDelOpen(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getBookList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoadingBtn(false);
				setDelOpen(false);
				errorToast(msg);
			})
			.send(() => { });
	};

export const updateBookListsApi =
	(formData, id, handleUpdClose, setLoadingBtn, getBookList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${LIBRARY_API}${id}`)
			.data(formData)
			.success((a) => {
				handleUpdClose();
				setLoadingBtn(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getBookList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				handleUpdClose();
				setLoadingBtn(false);
				errorToast(msg);
			})
			.send(() => { });
	};

//list of contact messages

export const getMessagesListApi =
	(SIZE, setListsize, page, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`${CONTACT_US_API}?page=${page}&limit=${SIZE}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					setListsize(a?.data?.totalCounts);
					dispatch(getMessageLists(a?.data?.data));
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				dispatch(getMessageLists([]));
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const replyMessageApi =
	(formData, setLoading, handleClose, getMessageLists) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(REPLY_API)
			.data(formData)
			.success((a) => {
				setLoading && setLoading(false);
				handleClose();
				if (a.statusCode === 200) {
					getMessageLists();
					Swal.fire('Thank you!', a.message, 'success');
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading && setLoading(false);
				handleClose();
			})
			.send(() => { });
	};

//start audio-----------
export const addAudioApi =
	(formData, setLoading, handleClose, getAudioList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(LIVE_AUDIO_API)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoading(false);
				if (a.statusCode === 200) {
					successToast(a?.message);
					getAudioList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				handleClose();
				setLoading(false);
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};

export const deleteAudioApi =
	(id, getAudioList, setLoadingBtn, setDelOpen) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.delete(`${LIVE_AUDIO_API}${id}`)
			.success((a) => {
				setLoadingBtn(false);
				setDelOpen(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getAudioList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn(false);
				setDelOpen(false);
			})
			.send(() => { });
	};

export const uploadAudioApi =
	(formData, id, setLoading, handleClose, getAudioList) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${LIVE_AUDIO_API}${id}`)
			.data(formData)
			.success((a) => {
				handleClose();
				setLoading(false);
				if (a.statusCode === 200) {
					successToast(a?.message);
					getAudioList();
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				handleClose();
				setLoading(false);
				const { message: msg = '' } = e;
				errorToast(msg);
			})
			.send(() => { });
	};
//end  audio--------------

// Legacy function - use createMasjidApi for new code
export const addFloorPlanApi =
	(formData, setLoading, navigate) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(MASJID_CREATE_API)
			.data(formData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 201 || response.statusCode === 200) {
					successToast(response.message || 'Masjid created successfully');
					navigate && navigate(FLOOR_PLAN);
				} else {
					errorToast(response.message || 'Failed to create Masjid');
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to create Masjid' } = error;
				errorToast(message);
			})
			.send(() => { });
	};

// Legacy function - use updateMasjidApi for new code
export const updateFloorPlanApi =
	(id, formData, handleUpdClose) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.put(`${MASJID_UPDATE_API}/${id}`)
			.data(formData)
			.success((response) => {
				handleUpdClose && handleUpdClose();
				if (response.statusCode === 200) {
					successToast(response.message || 'Masjid updated successfully');
				} else {
					errorToast(response.message || 'Failed to update Masjid');
				}
			})
			.error((error) => {
				handleUpdClose && handleUpdClose();
				const { message = 'Failed to update Masjid' } = error;
				errorToast(message);
			})
			.send(() => { });
	};
export const getFloorPlanListApi =
	(SIZE, setListsize, page, setLoading) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`${FLOORPLANAPI}?status=true&year=2024&page=${page}&limit=${SIZE}`)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200 || a.statusCode === 201) {
					dispatch(getFloorPlanLists(a?.data));
					setListsize(a?.data?.totalCounts);
				}
				if (
					a.statusCode === 400 ||
					a.statusCode === 401 ||
					a.statusCode === 403 ||
					a.statusCode === 404
				) {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

export const getMasjidListApi = (setLoading, setMasjidData) => (dispatch) => {
	setLoading && setLoading(true);

	api()
		.root(LOGIN_API_ROOT)
		.get(MASJID_LIST_API)
		.success((response) => {
			setLoading && setLoading(false);
			if (response.statusCode === 200 || response.statusCode === 201) {
				setMasjidData && setMasjidData(response?.data || []);
			} else {
				errorToast(response.message || 'Failed to fetch Masjids');
				setMasjidData && setMasjidData([]);
			}
		})
		.error((error) => {
			const { message = 'Failed to fetch Masjids' } = error;
			errorToast(message);
			setLoading && setLoading(false);
			setMasjidData && setMasjidData([]);
		})
		.send(() => { });
};

// Legacy function - use deleteMasjidApi for new code
export const deleteFloorPlanListApi =
	(id, getFloorPlanList, setLoadingBtn, setDelOpen) => (dispatch) => {
		setLoadingBtn && setLoadingBtn(true);

		api()
			.root(LOGIN_API_ROOT)
			.delete(`${MASJID_DELETE_API}/${id}`)
			.success((response) => {
				setLoadingBtn && setLoadingBtn(false);
				setDelOpen && setDelOpen(false);
				if (response.statusCode === 200) {
					successToast(response.message || 'Deleted Successfully');
					getFloorPlanList && getFloorPlanList();
				} else {
					errorToast(response.message || 'Failed to delete Masjid');
				}
			})
			.error((error) => {
				const { message = 'Failed to delete Masjid' } = error;
				errorToast(message);
				setLoadingBtn && setLoadingBtn(false);
				setDelOpen && setDelOpen(false);
			})
			.send(() => { });
	};

// Legacy function - use getMasjidByIdApi for new code
export const getFloorPlanListByIdApi = (id, setLoading) => (dispatch) => {
	setLoading && setLoading(true);

	api()
		.root(LOGIN_API_ROOT)
		.get(`${MASJID_GET_BY_ID_API}/${id}`)
		.success((response) => {
			setLoading && setLoading(false);
			if (response.statusCode === 200 || response.statusCode === 201) {
				dispatch(getFloorPlanListsById(response?.data));
			} else {
				errorToast(response.message || 'Masjid not found');
			}
		})
		.error((error) => {
			const { message = 'Failed to fetch Masjid' } = error;
			errorToast(message);
			setLoading && setLoading(false);
		})
		.send(() => { });
};

export const customApiRequest = async (method, url, data = null) => {
	try {
		let response;

		switch (method.toLowerCase()) {
			case 'get':
				response = await myAxiosInstance.get(url);
				break;
			case 'post':
				response = await myAxiosInstance.post(url, data);
				break;
			case 'put':
				response = await myAxiosInstance.put(url, data);
				break;
			case 'patch':
				response = await myAxiosInstance.patch(url, data);
				break;
			case 'delete':
				response = await myAxiosInstance.delete(url);
				break;
			// Add other cases for different HTTP methods as needed

			default:
				throw new Error(`Unsupported HTTP method: ${method}`);
		}

		return response.data;
	} catch (error) {
		throw error; // Rethrow the error for the caller to handle
	}
};

export const bookSelectedSeat =
	(
		formData,
		setLoading,
		getFloorPlanListById,
		setSelectedSeat,
		handleClose,
		getFloorPlanList,
	) =>
		(dispatch) => {
			setLoading && setLoading(true);
			api()
				.root(LOGIN_API_ROOT)
				.put('/athikaaf/assign-seat')
				.data(formData)
				.success((a) => {
					setLoading && setLoading(false);
					// handleClose();
					if (a.statusCode === 200) {
						getFloorPlanListById();
						getFloorPlanList();
						handleClose();
						setSelectedSeat([]);
						successToast(a.message);
						// dispatch(getFaqListApi());
					} else if (
						a.statusCode === 400 ||
						a.statusCode === 401 ||
						a.statusCode === 403 ||
						a.statusCode === 404
					) {
						errorToast(a.message);
					} else {
						errorToast(a.message);
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					errorToast(msg);
					// dispatch(getFaqLists([]));
					// handleClose();
					setLoading && setLoading(false);
				})
				.send(() => { });
		};

export const swapSelectedSeat =
	(formData, setLoading, setOpen, getFloorPlanListById, setSelectedSeat) =>
		(dispatch) => {
			setLoading && setLoading(true);
			api()
				.root(LOGIN_API_ROOT)
				.put('/athikaaf/swap-seat')
				.data(formData)
				.success((a) => {
					setLoading && setLoading(false);
					if (a.statusCode === 200) {
						successToast(a.message);
						setOpen(false);
						setSelectedSeat([]);
						getFloorPlanListById();
					} else if (a.statusCode === 203) {
						successToast(a.message);
						setOpen(true);
					} else {
						errorToast(a.message);
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					errorToast(msg);
					setLoading && setLoading(false);
				})
				.send(() => { });
		};

export const unassignSeat =
	(formData, setLoading, getFloorPlanListById) => (dispatch) => {
		setLoading && setLoading(true);
		api()
			.root(LOGIN_API_ROOT)
			.put('/athikaaf/unassign-seat')
			.data(formData)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getFloorPlanListById();
				} else {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoading && setLoading(false);
			})
			.send(() => { });
	};

// ==================== QR EVENT MANAGEMENT APIs ====================

// Get all active QR events
export const getActiveQrEventsApi = (setEvents, setLoading) => (dispatch) => {
	setLoading && setLoading(true);

	api()
		.root(LOGIN_API_ROOT)
		.get('/qr-events/active')
		.success((response) => {
			setLoading && setLoading(false);
			if (response.statusCode === 200) {
				setEvents(response.data?.data || []);
			} else {
				errorToast(response.message);
				setEvents([]);
			}
		})
		.error((error) => {
			setLoading && setLoading(false);
			const { message = 'Failed to fetch QR events' } = error;
			errorToast(message);
			setEvents([]);
		})
		.send();
};

// Get all QR events (for admin management)
export const getQrEventsApi =
	(setEvents, setTotalCount, setLoading) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get('/qr-events')
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					const events = response.data?.data || [];
					setEvents(events);
					setTotalCount && setTotalCount(events.length);
				} else {
					errorToast(response.message);
					setEvents([]);
					setTotalCount && setTotalCount(0);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch QR events' } = error;
				errorToast(message);
				setEvents([]);
				setTotalCount && setTotalCount(0);
			})
			.send();
	};

// Get single QR event by ID
export const getQrEventByIdApi =
	(eventId, setEvent, setLoading) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`/qr-events/${eventId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setEvent(response.data || null);
				} else {
					errorToast(response.message);
					setEvent(null);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch QR event' } = error;
				errorToast(message);
				setEvent(null);
			})
			.send();
	};

// Create a new QR event
export const createQrEventApi =
	(eventData, setLoading, onSuccess) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post('/qr-events')
			.data(eventData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 201) {
					successToast('QR Event created successfully');
					onSuccess && onSuccess(response.data?.data);
				} else {
					errorToast(response.message);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to create QR event', data } = error;

				// Handle validation errors
				if (data?.errors && Array.isArray(data.errors)) {
					const validationMessages = data.errors
						.map((err) => err.message)
						.join(', ');
					errorToast(`Validation Error: ${validationMessages}`);
				} else {
					errorToast(message);
				}
			})
			.send();
	};

// Update a QR event
export const updateQrEventApi =
	(eventId, eventData, setLoading, onSuccess) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.put(`/qr-events/${eventId}`)
			.data(eventData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast('QR Event updated successfully');
					onSuccess && onSuccess(response.data?.data);
				} else {
					errorToast(response.message);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to update QR event', data } = error;

				// Handle validation errors
				if (data?.errors && Array.isArray(data.errors)) {
					const validationMessages = data.errors
						.map((err) => err.message)
						.join(', ');
					errorToast(`Validation Error: ${validationMessages}`);
				} else {
					errorToast(message);
				}
			})
			.send();
	};

// Delete a QR event
export const deleteQrEventApi =
	(eventId, setLoading, onSuccess) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.delete(`/qr-events/${eventId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast('QR Event deleted successfully');
					onSuccess && onSuccess();
				} else {
					errorToast(response.message);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to delete QR event' } = error;
				errorToast(message);
			})
			.send();
	};

// Process QR scan for an event
export const processQrScanApi =
	(scanData, setLoading, onSuccess) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post('/qr-events/scan')
			.data(scanData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast('QR scan processed successfully');
					onSuccess && onSuccess(response.data?.data);
				} else {
					errorToast(response.message);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to process QR scan', data } = error;

				// Handle validation errors
				if (data?.errors && Array.isArray(data.errors)) {
					const validationMessages = data.errors
						.map((err) => err.message)
						.join(', ');
					errorToast(`Validation Error: ${validationMessages}`);
				} else {
					errorToast(message);
				}
			})
			.send();
	};

// Get QR event analytics
export const getQrEventAnalyticsApi =
	(eventId, filters, setAnalytics, setLoading) => (dispatch) => {
		setLoading && setLoading(true);

		const queryParams = new URLSearchParams({
			...(filters?.startDate && { startDate: filters.startDate }),
			...(filters?.endDate && { endDate: filters.endDate }),
			...(filters?.timeSlot && { timeSlot: filters.timeSlot }),
		});

		api()
			.root(LOGIN_API_ROOT)
			.get(`/qr-events/${eventId}/analytics?${queryParams}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setAnalytics(response.data?.data || {});
				} else {
					errorToast(response.message);
					setAnalytics({});
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch analytics' } = error;
				errorToast(message);
				setAnalytics({});
			})
			.send();
	};

// Get QR event logs
export const getQrEventLogsApi =
	(eventId, filters, setLogs, setLoading) => (dispatch) => {
		setLoading && setLoading(true);

		const queryParams = new URLSearchParams({
			page: (filters?.page || 1).toString(),
			limit: (filters?.limit || 50).toString(),
			...(filters?.startDate && { startDate: filters.startDate }),
			...(filters?.endDate && { endDate: filters.endDate }),
			...(filters?.timeSlot && { timeSlot: filters.timeSlot }),
		});

		api()
			.root(LOGIN_API_ROOT)
			.get(`/qr-events/${eventId}/logs?${queryParams}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setLogs(response.data?.data || []);
				} else {
					errorToast(response.message);
					setLogs([]);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch logs' } = error;
				errorToast(message);
				setLogs([]);
			})
			.send();
	};

// Get all QR event logs (admin view)
export const getAllQrEventLogsApi =
	(SIZE, setListsize, page, setLoading, search, eventFilter) => (dispatch) => {
		setLoading && setLoading(true);

		const queryParams = new URLSearchParams({
			page: page.toString(),
			limit: SIZE.toString(),
			...(search && { search }),
			...(eventFilter && { eventId: eventFilter }),
		});

		api()
			.root(LOGIN_API_ROOT)
			.get(`/qr-event-logs?${queryParams}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					dispatch(getQrEventLogsList(response.data?.logs || []));
					setListsize(response.data?.totalCounts || 0);
				} else {
					errorToast(response.message);
					dispatch(getQrEventLogsList([]));
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch QR event logs' } = error;
				errorToast(message);
				dispatch(getQrEventLogsList([]));
			})
			.send();
	};
// ============================================
// MASJID API FUNCTIONS
// ============================================

/**
 * Create a new Masjid with floor plan template
 * @param {Object} masjidData - Masjid data including name, city, masjidPicture, and floors
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const createMasjidApi =
	(masjidData, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(MASJID_CREATE_API)
			.data(masjidData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 201 || response.statusCode === 200) {
					successToast(
						response.message || 'Masjid created successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to create Masjid');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to create Masjid' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Update an existing Masjid
 * @param {string} masjidId - Masjid ID
 * @param {Object} updateData - Data to update (name, city, masjidPicture, or floorPlanTemplate)
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const updateMasjidApi =
	(masjidId, updateData, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.put(`${MASJID_UPDATE_API}/${masjidId}`)
			.data(updateData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(
						response.message || 'Masjid updated successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to update Masjid');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to update Masjid' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Get all Masjids
 * @param {Function} setLoading - Loading state setter
 * @param {Function} setMasjidList - Masjid list state setter
 */
export const getAllMasjidsApi = (setLoading, setMasjidList) => (dispatch) => {
	setLoading && setLoading(true);

	api()
		.root(LOGIN_API_ROOT)
		.get(MASJID_LIST_API)
		.success((response) => {
			setLoading && setLoading(false);
			if (response.statusCode === 200) {
				setMasjidList && setMasjidList(response.data || []);
			} else {
				errorToast(response.message || 'Failed to fetch Masjids');
				setMasjidList && setMasjidList([]);
			}
		})
		.error((error) => {
			setLoading && setLoading(false);
			const { message = 'Failed to fetch Masjids' } = error;
			errorToast(message);
			setMasjidList && setMasjidList([]);
		})
		.send();
};

/**
 * Get Masjid by ID
 * @param {string} masjidId - Masjid ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} setMasjidData - Masjid data state setter
 * @param {Function} onFailure - Failure callback
 */
export const getMasjidByIdApi =
	(masjidId, setLoading, setMasjidData, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${MASJID_GET_BY_ID_API}/${masjidId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setMasjidData && setMasjidData(response.data);
				} else {
					errorToast(response.message || 'Masjid not found');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch Masjid' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Delete Masjid
 * @param {string} masjidId - Masjid ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const deleteMasjidApi =
	(masjidId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.delete(`${MASJID_DELETE_API}/${masjidId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(response.message || 'Deleted Successfully');
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to delete Masjid');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to delete Masjid' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Get Floor Plan Template for a Masjid
 * @param {string} masjidId - Masjid ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} setFloorPlanTemplate - Floor plan template state setter
 * @param {Function} onFailure - Failure callback
 */
export const getFloorPlanTemplateApi =
	(masjidId, setLoading, setFloorPlanTemplate, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${MASJID_FLOOR_PLAN_TEMPLATE_API}/${masjidId}/floor-plan-template`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setFloorPlanTemplate && setFloorPlanTemplate(response.data);
				} else {
					errorToast(
						response.message || 'Failed to fetch floor plan template'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch floor plan template' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

// ============================================
// I'TIKAF EVENT API FUNCTIONS
// ============================================

/**
 * Create new I'tikaf event
 * @param {Object} eventData - Event data (name, eventType, description, masjidId, startDate, endDate, registrationStart, registrationEnd, floors)
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const createEventApi =
	(eventData, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(EVENT_CREATE_API)
			.data(eventData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 201) {
					successToast(
						response.message || "I'tikaf event created successfully"
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || "Failed to create I'tikaf event"
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to create I'tikaf event" } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.upload();
	};

/**
 * Get all I'tikaf events with optional filters
 * @param {Object} filters - Query parameters (masjidId, eventType, status, startYear, endYear)
 * @param {Function} setLoading - Loading state setter
 * @param {Function} setEventList - Event list state setter
 */
export const getAllEventsApi =
	(filters, setLoading, setEventList) => (dispatch) => {
		setLoading && setLoading(true);

		// Build query string from filters
		const queryParams = new URLSearchParams();
		if (filters?.masjidId) queryParams.append('masjidId', filters.masjidId);
		if (filters?.eventType) queryParams.append('eventType', filters.eventType);
		if (filters?.status) queryParams.append('status', filters.status);
		if (filters?.startYear) queryParams.append('startYear', filters.startYear);
		if (filters?.endYear) queryParams.append('endYear', filters.endYear);

		const queryString = queryParams.toString();
		const url = queryString ? `${EVENT_LIST_API}?${queryString}` : EVENT_LIST_API;

		api()
			.root(LOGIN_API_ROOT)
			.get(url)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setEventList && setEventList(response.data || []);
				} else {
					errorToast(
						response.message || "Failed to fetch I'tikaf events"
					);
					setEventList && setEventList([]);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to fetch I'tikaf events" } = error;
				errorToast(message);
				setEventList && setEventList([]);
			})
			.send();
	};

/**
 * Get I'tikaf event by ID
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} setEventData - Event data state setter
 * @param {Function} onFailure - Failure callback
 */
export const getEventByIdApi =
	(eventId, setLoading, setEventData, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${EVENT_GET_BY_ID_API}/${eventId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					setEventData && setEventData(response.data);
				} else {
					errorToast(response.message || 'Event not found');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch event' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Update I'tikaf event
 * @param {string} eventId - Event ID
 * @param {Object} updateData - Updated event data
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const updateEventApi =
	(eventId, updateData, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.put(`${EVENT_UPDATE_API}/${eventId}`)
			.data(updateData)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(
						response.message || 'Event updated successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to update event');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to update event' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.upload();
	};

export const testRegistrationNotificationApi =
	(payload, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(EVENT_TEST_NOTIFICATION_API)
			.data(payload)
			.success((response) => {
				if (response.statusCode === 200) {
					onSuccess && onSuccess(response);
				} else {
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Upload (or re-inspect, if `fileKey` is passed instead of a file) a confirmation
 * letter PDF template — returns its AcroForm field names, page dimensions, and a
 * page-1 preview image so the admin can map fields and place the QR code.
 * @param {FormData} formData - multipart body: either `template` (File) or `fileKey`/`url`
 * @param {Function} onSuccess - Success callback, receives response.data
 * @param {Function} onFailure - Failure callback
 */
export const inspectConfirmationLetterTemplateApi =
	(formData, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(EVENT_INSPECT_CONFIRMATION_LETTER_TEMPLATE_API)
			.data(formData)
			.success((response) => {
				if (response.statusCode === 200) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to inspect template');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				const { message = 'Failed to inspect template' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.upload();
	};

export const testConfirmationLetterNotificationApi =
	(payload, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(EVENT_TEST_CONFIRMATION_LETTER_NOTIFICATION_API)
			.data(payload)
			.success((response) => {
				if (response.statusCode === 200) {
					onSuccess && onSuccess(response);
				} else {
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Archive I'tikaf event
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const archiveEventApi =
	(eventId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${EVENT_ARCHIVE_API}/${eventId}/archive`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(
						response.message || 'Event archived successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to archive event');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to archive event' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Delete I'tikaf event
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const deleteEventApi =
	(eventId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.delete(`${EVENT_DELETE_API}/${eventId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(
						response.message || 'Event deleted successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to delete event');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to delete event' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

//============================================================
// EVENT REGISTRATION MANAGEMENT APIs
//============================================================

/**
 * Get all registrations for an event with filtering and pagination
 * @param {string} eventId - Event ID
 * @param {Object} params - Query parameters (status, search, page, limit, sortBy, sortOrder)
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback with data
 * @param {Function} onFailure - Failure callback
 */
export const getEventRegistrationsApi =
	(eventId, params = {}, setLoading, onSuccess, onFailure) =>
		(dispatch) => {
			setLoading && setLoading(true);

			const queryParams = new URLSearchParams();
			if (params.status) queryParams.append('status', params.status);
			if (params.search) queryParams.append('search', params.search);
			if (params.page) queryParams.append('page', params.page);
			if (params.limit) queryParams.append('limit', params.limit);
			if (params.sortBy) queryParams.append('sortBy', params.sortBy);
			if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
			if (params.etekaafType) queryParams.append('etekaafType', params.etekaafType);
			if (params.registrationDateFrom) queryParams.append('registrationDateFrom', params.registrationDateFrom);
			if (params.registrationDateTo) queryParams.append('registrationDateTo', params.registrationDateTo);
			if (Array.isArray(params.city) && params.city.length > 0) {
				queryParams.append('city', params.city.join(','));
			}
			if (Array.isArray(params.state) && params.state.length > 0) {
				queryParams.append('state', params.state.join(','));
			}

			const queryString = queryParams.toString();
			const url = `${EVENT_REGISTRATIONS_API}/${eventId}/registrations${queryString ? `?${queryString}` : ''
				}`;

			api()
				.root(LOGIN_API_ROOT)
				.get(url)
				.success((response) => {
					setLoading && setLoading(false);
					if (response.statusCode === 200 || response.success) {
						onSuccess && onSuccess(response.data);
					} else {
						errorToast(
							response.message || 'Failed to fetch registrations'
						);
						onFailure && onFailure(response);
					}
				})
				.error((error) => {
					setLoading && setLoading(false);
					const { message = 'Failed to fetch registrations' } = error;
					errorToast(message);
					onFailure && onFailure(error);
				})
				.send();
		};

/**
 * Get registration statistics for an event
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback with stats data
 * @param {Function} onFailure - Failure callback
 */
export const getEventRegistrationStatsApi =
	(eventId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${EVENT_REGISTRATIONS_STATS_API}/${eventId}/registrations/stats`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to fetch stats');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch stats' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Scan QR code for event check-in
 * @param {string} eventId - Event ID
 * @param {string} identifier - Registration ID or User ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback with scan data
 * @param {Function} onFailure - Failure callback
 */
export const scanQrCodeApi =
	({ eventId, identifier, setLoading, onSuccess, onFailure }) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${EVENT_SCAN_QR_API}/${eventId}/scan-qr`)
			.data({ identifier })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to scan QR code');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to scan QR code' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

export const scanQrCheckoutApi =
	({ eventId, identifier, setLoading, onSuccess, onFailure }) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${EVENT_SCAN_QR_API}/${eventId}/scan-qr-checkout`)
			.data({ identifier })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to scan QR code for checkout');
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to scan QR code for checkout' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Get single registration details
 * @param {string} registrationId - Registration ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback with registration data
 * @param {Function} onFailure - Failure callback
 */
export const getRegistrationByIdApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${REGISTRATION_GET_BY_ID_API}/${registrationId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to fetch registration'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to fetch registration' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Accept/Approve a registration
 * @param {string} registrationId - Registration ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const acceptRegistrationApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${REGISTRATION_ACCEPT_API}/${registrationId}/accept`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Registration accepted successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to accept registration'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to accept registration' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Reject a registration
 * @param {string} registrationId - Registration ID
 * @param {string} reason - Optional rejection reason
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const rejectRegistrationApi =
	(registrationId, reason, setLoading, onSuccess, onFailure) =>
		(dispatch) => {
			setLoading && setLoading(true);

			const data = reason ? { reason } : {};

			api()
				.root(LOGIN_API_ROOT)
				.post(`${REGISTRATION_REJECT_API}/${registrationId}/reject`)
				.data(data)
				.success((response) => {
					setLoading && setLoading(false);
					if (response.statusCode === 200 || response.success) {
						successToast(
							response.message || 'Registration rejected successfully'
						);
						onSuccess && onSuccess(response.data);
					} else {
						errorToast(
							response.message || 'Failed to reject registration'
						);
						onFailure && onFailure(response);
					}
				})
				.error((error) => {
					setLoading && setLoading(false);
					const { message = 'Failed to reject registration' } = error;
					errorToast(message);
					onFailure && onFailure(error);
				})
				.send();
		};

/**
 * Bulk accept multiple registrations
 * @param {Array<string>} registrationIds - Array of registration IDs
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const bulkAcceptRegistrationsApi =
	(registrationIds, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(REGISTRATION_BULK_ACCEPT_API)
			.data({ registrationIds })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Registrations accepted successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to accept registrations'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to accept registrations' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Send confirmation notification to accepted user
 * @param {string} registrationId - Registration ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const sendConfirmationNotificationApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${REGISTRATION_SEND_CONFIRMATION_API}/${registrationId}/send-confirmation`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Confirmation notification sent successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to send confirmation'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to send confirmation' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Assign seat to a confirmed registration
 * @param {string} registrationId - Registration ID
 * @param {Object} seatData - { floorIndex, rowIndex, seatIndex }
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const assignSeatApi =
	(registrationId, seatData, setLoading, onSuccess, onFailure) =>
		(dispatch) => {
			setLoading && setLoading(true);

			api()
				.root(LOGIN_API_ROOT)
				.post(`${REGISTRATION_ASSIGN_SEAT_API}/${registrationId}/assign-seat`)
				.data(seatData)
				.success((response) => {
					setLoading && setLoading(false);
					if (response.statusCode === 200 || response.success) {
						successToast(
							response.message || 'Seat assigned successfully'
						);
						onSuccess && onSuccess(response.data);
					} else {
						errorToast(response.message || 'Failed to assign seat');
						onFailure && onFailure(response);
					}
				})
				.error((error) => {
					setLoading && setLoading(false);
					const { message = 'Failed to assign seat' } = error;
					errorToast(message);
					onFailure && onFailure(error);
				})
				.send();
		};

/**
 * Bulk reject registrations
 * @param {Array} registrationIds - Array of registration IDs
 * @param {string} reason - Rejection reason (optional)
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const bulkRejectRegistrationsApi =
	(registrationIds, reason, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(REGISTRATION_BULK_REJECT_API)
			.data({ registrationIds, reason })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Registrations rejected successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to reject registrations'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to reject registrations' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Bulk send confirmation notifications
 * @param {Array} registrationIds - Array of registration IDs
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const bulkSendConfirmationApi =
	(registrationIds, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(REGISTRATION_BULK_SEND_CONFIRMATION_API)
			.data({ registrationIds })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Confirmation notifications sent successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to send confirmation notifications'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to send confirmation notifications' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Bulk resend the WhatsApp template(s) configured for a workflow step to a selection
 * of registrations already in that step's status
 * @param {Array<string>} registrationIds - Registration IDs to resend to
 * @param {string} step - registrationNotification|approvalNotification|rejectionNotification|userConfirmedNotification|userDeclinedNotification|confirmationLetter
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const bulkResendNotificationApi =
	(registrationIds, step, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(REGISTRATION_BULK_RESEND_NOTIFICATION_API)
			.data({ registrationIds, step })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Notification resent successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to resend notification'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to resend notification' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Update I'tikaf type for a registration
 * @param {string} registrationId - Registration ID
 * @param {Object} data - { itakaafType, nafilStartDate?, nafilEndDate? }
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const updateItikaafTypeApi =
	(registrationId, data, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.put(`${REGISTRATION_UPDATE_ITIKAAF_TYPE_API}/${registrationId}/update-itikaaf-type`)
			.data(data)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || "I'tikaf type updated successfully"
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || "Failed to update I'tikaf type"
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to update I'tikaf type" } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Get seat map with assignments for an event
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const getEventSeatMapApi =
	(eventId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${EVENT_SEAT_MAP_API}/${eventId}/seat-map`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || "Failed to load seat map"
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to load seat map" } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Bulk assign seats to registrations
 * @param {Array} assignments - Array of { registrationId, floorIndex, rowIndex, seatIndex }
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const bulkAssignSeatsApi =
	(assignments, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(REGISTRATION_BULK_ASSIGN_SEATS_API)
			.data(assignments)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || "Seat assignment completed successfully"
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || "Failed to assign seats"
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to assign seats" } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Unassign seat from a registration
 * @param {string} registrationId - Registration ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const unassignSeatApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${REGISTRATION_UNASSIGN_SEAT_API}/${registrationId}/unassign-seat`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || "Seat unassigned successfully"
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || "Failed to unassign seat"
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to unassign seat" } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Swap seats between two registrations or move a user to an empty seat
 * @param {Object} params - Swap parameters
 *   For user-to-user swap: { registration1Id, registration2Id }
 *   For move to empty: { registration1Id, floorIndex, rowIndex, seatIndex }
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const swapSeatsApi =
	(params, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(REGISTRATION_SWAP_SEATS_API)
			.data(params)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || "Seats swapped successfully"
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || "Failed to swap seats"
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = "Failed to swap seats" } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Delete a registration
 * @param {string} registrationId - Registration ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const deleteRegistrationApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.delete(`${REGISTRATION_DELETE_API}/${registrationId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Registration deleted successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to delete registration'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to delete registration' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

//============================================================
// PRINT BATCH MANAGEMENT APIs
//============================================================

/**
 * List which generated-document templates are available to zip for an event
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const getEventDocumentTemplatesApi =
	(eventId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${PRINT_BATCH_CREATE_API}/${eventId}/document-templates`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to load available documents'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to load available documents' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Create a zip export of one document template's generated files for an event
 * @param {string} eventId - Event ID
 * @param {string} templateName - Which generated-document template to zip
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const createPrintBatchApi =
	(eventId, templateName, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.post(`${PRINT_BATCH_CREATE_API}/${eventId}/print-export`)
			.data({ templateName })
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					successToast(
						response.message || 'Print batch export initiated successfully'
					);
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to initiate print batch export'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to initiate print batch export' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Get print batch status
 * @param {string} batchId - Batch ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const getPrintBatchStatusApi =
	(batchId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${PRINT_BATCH_STATUS_API}/${batchId}/status`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to get print batch status'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to get print batch status' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

/**
 * Get all print batches for an event
 * @param {string} eventId - Event ID
 * @param {Function} setLoading - Loading state setter
 * @param {Function} onSuccess - Success callback
 * @param {Function} onFailure - Failure callback
 */
export const getPrintBatchesApi =
	(eventId, setLoading, onSuccess, onFailure) => (dispatch) => {
		setLoading && setLoading(true);

		api()
			.root(LOGIN_API_ROOT)
			.get(`${PRINT_BATCH_LIST_API}/${eventId}/print-batches`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200 || response.success) {
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(
						response.message || 'Failed to get print batches'
					);
					onFailure && onFailure(response);
				}
			})
			.error((error) => {
				setLoading && setLoading(false);
				const { message = 'Failed to get print batches' } = error;
				errorToast(message);
				onFailure && onFailure(error);
			})
			.send();
	};

